import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import creatorService from './creatorService'

const initialState = {
  maps: [],
  // For getters
  isErrorGetting: false,
  isSuccessGetting: false,
  // For create/edit/delete (modifiers)
  isErrorManipulating: false,
  isSuccessManipulating: false,
  isLoading: false,
  message: ''
}

export const createMap = createAsyncThunk('creator/createMap', async (projectData, thunkAPI) => {
  try {
    const token = thunkAPI.getState().auth.user.token
    return await creatorService.createMap(projectData, token)
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

    // console.log(error)
    return thunkAPI.rejectWithValue(message)
  }
})

export const getMaps = createAsyncThunk('creator/getAll', async (_, thunkAPI) => {
  try {
    const token = thunkAPI.getState().auth.user.token
    return await creatorService.getMaps(token)
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

    // console.log(error)
    return thunkAPI.rejectWithValue(message)
  }
})

export const updateMap = createAsyncThunk('creator/updateMap', async (projectData, thunkAPI) => {
  try {
    const token = thunkAPI.getState().auth.user.token
    return await creatorService.updateMap(projectData, token)
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

    // console.log(error)
    return thunkAPI.rejectWithValue(message)
  }
})

export const addLayer = createAsyncThunk('creator/addLayer', async (projectData, thunkAPI) => {
  try {
    const token = thunkAPI.getState().auth.user.token
    return await creatorService.addLayer(projectData, token)
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

    // console.log(error)
    return thunkAPI.rejectWithValue(message)
  }
})

export const editLayer = createAsyncThunk('creator/editLayer', async (projectData, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await creatorService.editLayer(projectData, token)
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
  
      // console.log(error)
      return thunkAPI.rejectWithValue(message)
    }
  })

export const deleteLayer = createAsyncThunk('creator/deleteLayer', async (projectData, thunkAPI) => {
  try {
    const token = thunkAPI.getState().auth.user.token
    return await creatorService.deleteLayer(projectData, token)
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()

    // console.log(error)
    return thunkAPI.rejectWithValue(message)
  }
})

export const creatorSlice = createSlice({
  name: 'creator',
  initialState,
  reducers: {
    reset: (state) => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(createMap.pending, (state) => {
        state.isLoading = true
      })
      .addCase(createMap.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccessManipulating = true
        state.maps.push(action.payload)
      })
      .addCase(createMap.rejected, (state, action) => {
        state.isLoading = false
        state.isErrorManipulating = true
        state.message = action.payload
      })

      .addCase(getMaps.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getMaps.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccessGetting = true
        state.maps = action.payload
      })
      .addCase(getMaps.rejected, (state, action) => {
        state.isLoading = false
        state.isErrorGetting = true
        state.message = action.payload
      })

      .addCase(updateMap.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateMap.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccessManipulating = true
        state.maps = state.maps.filter(
          (map) => map._id !== action.payload.updatedMap._id
        )
      })
      .addCase(updateMap.rejected, (state, action) => {
        state.isLoading = false
        state.isErrorManipulating = true
        state.message = action.payload
      })

      .addCase(addLayer.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addLayer.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccessManipulating = true
        state.maps = state.maps.filter(
          (map) => map._id !== action.payload.updatedMap._id
        )
        state.maps.push(action.payload.updatedMap)
      })
      .addCase(addLayer.rejected, (state, action) => {
        state.isLoading = false
        state.isErrorManipulating = true
        state.message = action.payload
      })

      .addCase(editLayer.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editLayer.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccessManipulating = true
        state.maps = state.maps.filter(
          (map) => map._id !== action.payload.updatedMap._id
        )
        state.maps.push(action.payload.updatedMap)
      })
      .addCase(editLayer.rejected, (state, action) => {
        state.isLoading = false
        state.isErrorManipulating = true
        state.message = action.payload
      })

      .addCase(deleteLayer.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteLayer.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccessManipulating = true
        state.maps = state.maps.filter(
          (map) => map._id !== action.payload.updatedMap._id
        )
        state.maps.push(action.payload.updatedMap)
      })
      .addCase(deleteLayer.rejected, (state, action) => {
        state.isLoading = false
        state.isErrorManipulating = true
        state.message = action.payload
      })
  }
})

export const { reset } = creatorSlice.actions
export default creatorSlice.reducer